<template>
  <v-footer class="font-weight-medium">
    <v-col cols="12">
      <small><strong>Instituto Pró-Hemoce</strong> - Sistema Administrativo - &copy; 2020</small>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>
